import { darken } from 'polished';
import { isHexColor } from '../helpers/isHexColor';

const DEFAULT_PRIMARY_COLOR = '#006FE5'

export const setCustomColor = (customColor: string, container?: HTMLElement | null) => {
  const primaryColor = isHexColor(customColor || '') ? customColor : DEFAULT_PRIMARY_COLOR;
  const primaryHoverColor = darken(0.1, primaryColor);
  const resolvedContainer = (
    container ||
    (document.querySelector('.osirus-agent') as HTMLElement | null)
  ) as HTMLDivElement | null;
  resolvedContainer?.style.setProperty('--osirus-agent-primary-color', primaryColor);
  resolvedContainer?.style.setProperty('--osirus-agent-primary-hover-color', primaryHoverColor);
  resolvedContainer?.style.setProperty('--osirus-agent-text-color', isColorTooLight(primaryColor) ? '#000000' : '#ffffff');
  resolvedContainer?.style.setProperty('--osirus-agent-invert-filter', isColorTooLight(primaryColor) ? '0' : '1');
}

function calculateLuminance(hexColor: string) {
  hexColor = hexColor.replace('#', '');

  // Convert the hex color to its RGB components
  const r = parseInt(hexColor.slice(0, 2), 16) / 255;
  const g = parseInt(hexColor.slice(2, 4), 16) / 255;
  const b = parseInt(hexColor.slice(4, 6), 16) / 255;

  // Apply the formula for relative luminance
  const luminance = 0.2126 * r + 0.7152 * g + 0.0722 * b;

  return luminance;
}

export function isColorTooLight(hexColor: string) {
  const luminance = calculateLuminance(hexColor);

  // You can adjust this threshold value as needed
  // Lower values make it more strict, higher values make it more permissive
  const threshold = 0.5;

  return luminance > threshold;
}
